export class Inheritance {
  parentId: string;
  includeUpdate: boolean;
  includeDelete: boolean;
  constructor() {
    this.parentId = '';
    this.includeUpdate = false;
    this.includeDelete = false;
  }
}

